import jQuery from "jquery";
import { EVENT, currency } from "../data/constants";
import SERVICE_REGISTRY from "../services/registry";
import { SETTINGS } from "../settings";
import templates from "../templates";
import {
    EventManager,
    addBrandIconMarker,
    concatenateStoreAddress,
    concatenateStoreHours,
    formatDateByCountry,
    formatStoreDistanceValue,
    generateHoursLiArray,
    getMoreInfoLink,
    getProductHotData,
    getProductImageUrl,
    getProductName,
    open247,
} from "../utils/global";

const $ = jQuery;

export default class DetailView extends woosmap.map.MVCObject {
    constructor(mainView, language) {
        super();

        this.selector = "#storemap-detailbar-container";

        this.mainView = mainView;
        this.store = null;
        this.language = language;

        this.mainElement = document.querySelector(this.selector);
        this.mainElement.innerHTML = templates.mobile.detail.render(total.maps.L10n.ui);

        this._wireEvents();
    }

    _wireEvents() {
        const self = this;

        function onGoButtonClick() {
            self.mainView.showDirection();
            EventManager.notify(EVENT.GO_CLICKED, self.store.properties.store_id);
        }

        const onWebUrlLinkClick = () => {
            EventManager.notify(EVENT.DETAIL_CLICKED);
        };

        function onCallLinkClick() {
            EventManager.notify(EVENT.CALL_CLICKED);
        }

        const directionsElement = this.mainElement.querySelector(".storemap-detailitem-direction-button");
        if (directionsElement) {
            directionsElement.addEventListener("click", onGoButtonClick);
        }
        this.mainElement.querySelector(".storemap-web-url-link").addEventListener("click", onWebUrlLinkClick);
        this.mainElement
            .querySelector(".storemap-maplistitem-telephone-link")
            .addEventListener("click", onCallLinkClick);
    }

    show() {
        this.mainElement.style.display = "";
    }

    hide() {
        this.mainElement.style.display = "none";
    }

    hydrateStoreDetail(store) {
        console.log("hydrateStoreDetail");
        if (!store) return;

        this.mainElement.querySelector(".storemap-detailitem-info-fuel").style.display = "none";
        this.mainElement.querySelector(".storemap-detailitem-legal-notice").style.display = "none";

        this.mainView.setSelectedStore(store);

        this.store = store;

        // icon
        const logoItem = this.mainElement.querySelector(".storemap-detailitem-logo");
        addBrandIconMarker(logoItem, store);

        // name
        this.mainElement.querySelector(".storemap-detailitem-storename").textContent = store.properties.name;

        // type
        const type = store.properties.user_properties.poiType;
        const poiTypeToDisplay = total.maps.L10n.ui.poiType[type] ? total.maps.L10n.ui.poiType[type] : type;
        this.mainElement.querySelector(".storemap-detailitem-storetype").textContent = poiTypeToDisplay;

        // code iata and code icao
        // specific to aviation
        if (SETTINGS.isAviationPortal) {
            let codes = store.properties.store_id;
            if (store.properties.user_properties.iata_code) {
                codes += ` / ${store.properties.user_properties.iata_code}`;
            }
            this.mainElement.querySelector(".storemap-detailitem-icao-iata").textContent = codes;
            this.mainElement.querySelector(".storemap-detailitem-icao-iata").style.display = "";
        } else {
            this.mainElement.querySelector(".storemap-detailitem-icao-iata").textContent = "";
            this.mainElement.querySelector(".storemap-detailitem-icao-iata").style.display = "none";
        }

        // distance
        if (store.properties.distance) {
            const distanceText = formatStoreDistanceValue(store);
            this.mainElement.querySelector(".storemap-detailitem-distance").textContent = distanceText;
        } else {
            this.mainElement.querySelector(".storemap-detailitem-distance").textContent = "";
        }

        // open

        if (store.properties.open?.open_now) {
            this.mainElement.querySelector(".storemap-detailitem-todayshours").style.display = "";
            const hoursText = concatenateStoreHours(store.properties.open.open_hours);

            this.mainElement.querySelector(".storemap-detailitem-todayshours > div").textContent =
                `${total.maps.L10n.ui.common.today} ${hoursText}`;
        } else {
            this.mainElement.querySelector(".storemap-detailitem-todayshours").style.display = "none";
        }

        // address
        const address = concatenateStoreAddress(store);
        this.mainElement.querySelector(".storemap-detailitem-info-adresse").textContent = address;

        // phone
        if (
            store.properties.user_properties.contacts?.first_tel &&
            store.properties.user_properties.contacts.first_tel.value !== ""
        ) {
            this.mainElement.querySelector(".storemap-detailitem-info-telephone").style.display = "";
            this.mainElement.querySelector(".storemap-telephone-number").textContent =
                store.properties.user_properties.contacts.first_tel.value;

            const blockElement = this.mainElement.querySelector(".storemap-telephone-block");
            if (SETTINGS.isAviationPortal) {
                const { name } = store.properties.user_properties.contacts.first_tel;
                const { job } = store.properties.user_properties.contacts.first_tel;

                const nameElement = this.mainElement.querySelector(".storemap-telephone-name");
                const jobElement = this.mainElement.querySelector(".storemap-telephone-job");
                const separatorElement = this.mainElement.querySelector(".storemap-telephone-separator");

                if (name && name !== "" && job && job !== "") {
                    if (name && name !== "") {
                        nameElement.textContent = name;

                        if (job && job !== "") {
                            jobElement.textContent = job;
                            separatorElement.style.display = "";
                        }
                    } else {
                        nameElement.textContent = "";
                        jobElement.textContent = "";
                        separatorElement.style.display = "none";
                    }
                    blockElement.style.display = "";
                } else {
                    blockElement.style.display = "none";
                }
            } else {
                blockElement.style.display = "none";
            }
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-telephone").style.display = "none";
        }

        // phone 2
        if (SETTINGS.isAviationPortal) {
            if (
                store.properties.user_properties.contacts?.second_tel &&
                store.properties.user_properties.contacts.second_tel.value !== ""
            ) {
                this.mainElement.querySelector(".storemap-detailitem-info-telephone2").style.display = "";
                this.mainElement.querySelector(".storemap-telephone2-number").textContent =
                    store.properties.user_properties.contacts.second_tel.value;

                const blockElement = this.mainElement.querySelector(".storemap-telephone2-block");
                const nameElement = this.mainElement.querySelector(".storemap-telephone2-name");
                const jobElement = this.mainElement.querySelector(".storemap-telephone2-job");
                const separatorElement = this.mainElement.querySelector(".storemap-telephone2-separator");

                const { name } = store.properties.user_properties.contacts.second_tel;
                const { job } = store.properties.user_properties.contacts.second_tel;

                if (name && name !== "" && job && job !== "") {
                    if (name && name !== "") {
                        nameElement.textContent = name;
                        if (job && job !== "") {
                            jobElement.textContent = job;
                            separatorElement.style.display = "";
                        }
                    } else {
                        nameElement.textContent = "";
                        jobElement.textContent = "";
                        separatorElement.style.display = "none";
                    }
                    blockElement.style.display = "";
                } else {
                    blockElement.style.display = "none";
                }
            } else {
                this.mainElement.querySelector(".storemap-detailitem-info-telephone2").style.display = "none";
            }
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-telephone2").style.display = "none";
        }

        // fax
        if (SETTINGS.isAviationPortal) {
            if (
                store.properties.user_properties.contacts?.fax &&
                store.properties.user_properties.contacts.fax.value !== ""
            ) {
                this.mainElement.querySelector(".storemap-detailitem-info-fax").style.display = "";
                this.mainElement.querySelector(".storemap-fax-number").textContent =
                    store.properties.user_properties.contacts.fax.value;
                this.mainElement.querySelector(".storemap-fax-name").textContent =
                    store.properties.user_properties.contacts.fax.name;
                this.mainElement.querySelector(".storemap-fax-job").textContent =
                    store.properties.user_properties.contacts.fax.job;
            } else {
                this.mainElement.querySelector(".storemap-detailitem-info-fax").style.display = "none";
            }
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-fax").style.display = "none";
        }

        // more info link
        const moreInfoURL = store?.properties?.contact?.website
            ? store.properties.contact.website
            : getMoreInfoLink(
                  store.properties.address.country_code,
                  this.language,
                  store.properties.user_properties.poiType,
                  store.properties.user_properties.location_id,
              );

        if (moreInfoURL) {
            this.mainElement.querySelector(".storemap-detailitem-info-web").style.display = "";
            this.mainElement.querySelector(".storemap-web-url-link").setAttribute("href", moreInfoURL);
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-web").style.display = "none";
        }

        // website
        // if(SETTINGS.isAviationPortal){
        // if (store.properties.user_properties.contacts?.website?.value) {
        //     this.mainElement.querySelector(".storemap-detailitem-info-website").style.display = "";
        //     this.mainElement
        //         .querySelector(".storemap-detailitem-info-website .storemap-web-url-link")
        //         .setAttribute("href", store.properties.user_properties.contacts.website.value);
        //     if (
        //         store.properties.user_properties.contacts.website.name &&
        //         store.properties.user_properties.contacts.website.name !== ""
        //     ) {
        //         this.mainElement.querySelector(".storemap-detailitem-info-website .storemap-web-url-link").textContent =
        //             store.properties.user_properties.contacts.website.name;
        //     } else {
        //         this.mainElement.querySelector(".storemap-detailitem-info-website .storemap-web-url-link").textContent =
        //             "Website";
        //     }
        // } else {
        //     this.mainElement.querySelector(".storemap-detailitem-info-website").style.display = "none";
        // }

        // email
        if (SETTINGS.isAviationPortal) {
            if (store.properties.user_properties.contacts?.email?.value) {
                this.mainElement.querySelector(".storemap-detailitem-info-email").style.display = "";
                this.mainElement.querySelector(".storemap-email-link").textContent =
                    store.properties.user_properties.contacts.email.name;
                this.mainElement
                    .querySelector(".storemap-email-link")
                    .setAttribute("href", `mailto:${store.properties.user_properties.contacts.email.value}`);
            } else {
                this.mainElement.querySelector(".storemap-detailitem-info-email").style.display = "none";
            }
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-email").style.display = "none";
        }
        // open hours
        if (store.properties.opening_hours?.usual) {
            const ulOpeningHours = this.mainElement.querySelector(".storemap-openinghours");
            const lisToRemove = ulOpeningHours.querySelectorAll("li");
            if (lisToRemove) {
                for (const liToRemove of lisToRemove) {
                    liToRemove.remove();
                }
            }

            const openingHoursArray = generateHoursLiArray(store);

            if (openingHoursArray.length !== 0) {
                for (const li of openingHoursArray) {
                    ulOpeningHours.append(li);
                }
                this.mainElement.querySelector(".storemap-detailitem-info-openinghours").style.display = "";
            } else {
                this.mainElement.querySelector(".storemap-detailitem-info-openinghours").style.display = "none";
            }
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-openinghours").style.display = "none";
        }

        // open 24/7
        function displayIf(element, condition) {
            let display = "none";
            if (condition) {
                display = "";
            }

            element.style.display = display;
        }

        displayIf(document.querySelector(".storemap-detailitem-24hours"), open247(store));

        // phone
        if (
            store.properties.user_properties.contacts?.first_tel &&
            store.properties.user_properties.contacts.first_tel.value !== ""
        ) {
            this.mainElement
                .querySelector(".storemap-maplistitem-telephone-link")
                .setAttribute("href", `tel:${store.properties.user_properties.contacts.first_tel.value}`);
        }

        // phone 2
        if (SETTINGS.isAviationPortal) {
            if (
                store.properties.user_properties.contacts?.second_tel &&
                store.properties.user_properties.contacts.second_tel.value !== ""
            ) {
                this.mainElement.querySelector(".storemap-detailitem-info-telephone2").style.display = "";
                this.mainElement.querySelector(".storemap-telephone2-number").textContent =
                    store.properties.user_properties.contacts.second_tel.value;
                this.mainElement.querySelector(".storemap-telephone2-name").textContent =
                    store.properties.user_properties.contacts.second_tel.name;
                this.mainElement.querySelector(".storemap-telephone2-job").textContent =
                    store.properties.user_properties.contacts.second_tel.job;
            } else {
                this.mainElement.querySelector(".storemap-detailitem-info-telephone2").style.display = "none";
            }
        } else {
            this.mainElement.querySelector(".storemap-detailitem-info-telephone2").style.display = "none";
        }

        // products icons
        if (SETTINGS.showPrices && store.properties.user_properties.poiType === "FUELING") {
            SERVICE_REGISTRY.priceService.getHotData(store.properties.user_properties.location_id, (productData) => {
                this._generateProductContainer(store, productData);
            });
        } else {
            this._generateProductContainer(store);
        }
    }

    _feedRequisitionContainer(requMessage) {
        const requisitionInfo = this.mainElement.querySelector(".storemap-detailitem-info-requisition");
        if (requMessage && requMessage !== "") {
            requisitionInfo.textContent = requMessage;
            requisitionInfo.style.display = "";
        } else {
            requisitionInfo.style.display = "none";
        }
    }

    _generateProductContainer(store, prices) {
        const fuels = total.maps.parameters.fuel;
        const currentFuelTags = [];

        for (const tag of store.properties.tags) {
            if (fuels && fuels.indexOf(tag) !== -1) {
                currentFuelTags.push(tag);
            }
        }

        if (currentFuelTags.length === 0) {
            this.mainElement.querySelector(".storemap-detailitem-info-fuel").style.display = "none";
            this.mainElement.querySelector(".storemap-detailitem-legal-notice").style.display = "none";
        } else {
            const fuelItemsContainer = this.mainElement.querySelector(".storemap-fuel");

            let priceData;
            let priceUpdateText;

            fuelItemsContainer.innerHTML = "";
            for (const tag of currentFuelTags) {
                try {
                    if (prices) {
                        priceData = getProductHotData(prices, tag);
                    } else {
                        priceData = null;
                    }
                } catch (error) {
                    console.log(error);
                }
                fuelItemsContainer.innerHTML += templates.mobile.detailProductItem.render({
                    name: getProductName(store, tag),
                    iconUrl: getProductImageUrl(store, tag),
                    priceData,
                    crossIconUrl: `${SETTINGS.serverUrl}css/images/red-cross.png`,
                });
                if (priceData !== null) {
                    if (!priceUpdateText || priceUpdateText < priceData.updateDate) {
                        priceUpdateText = priceData.updateDate;
                    }
                }
            }

            this.mainElement.querySelector(".storemap-detailitem-info-fuel").style.display = "";

            if (priceUpdateText) {
                priceUpdateText = formatDateByCountry(priceUpdateText);

                this.mainElement.querySelector(".storemap-detailitem-update-date-info").textContent = priceUpdateText;
                this.mainElement.querySelector(".storemap-detailitem-legal-notice").style.display = "";
            } else {
                this.mainElement.querySelector(".storemap-detailitem-legal-notice").style.display = "none";
            }
        }
    }
}
